import React from 'react';

import {
    DEFAULT_FC_TRANSFER_DIRECTION,
    FC_TRANSFER_DIRECTION,
} from 'components/warehouse/components/fcTransfers/FCTransferFilterConfig';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'shadcn/components/ui/Tabs';

/**
 * Outbound / Inbound tabs as direction filter UI (tech spec §5.2).
 *
 * @param {Object} props
 * @param {import('components/warehouse/components/fcTransfers/FCTransferFilterConfig').FcTransferDirection} [props.value] - Controlled direction.
 * @param {import('components/warehouse/components/fcTransfers/FCTransferFilterConfig').FcTransferDirection} [props.defaultValue] - Uncontrolled default.
 * @param {(next: import('components/warehouse/components/fcTransfers/FCTransferFilterConfig').FcTransferDirection) => void} [props.onValueChange]
 * @param {string} [props.className]
 */
export function FCTransferDirectionTabs({
    className,
    defaultValue = DEFAULT_FC_TRANSFER_DIRECTION,
    onValueChange,
    value: valueProp,
}) {
    const isControlled = valueProp !== undefined;

    return (
        <Tabs
            className={className}
            value={isControlled ? valueProp : undefined}
            defaultValue={isControlled ? undefined : defaultValue}
            onValueChange={onValueChange}
        >
            <TabsList className="w-fit">
                <TabsTrigger value={FC_TRANSFER_DIRECTION.OUTBOUND}>Outbound Transfers</TabsTrigger>
                <TabsTrigger value={FC_TRANSFER_DIRECTION.INBOUND}>Inbound Transfers</TabsTrigger>
            </TabsList>
            {/* Radix Tabs expects content nodes per panel; list container owns filter body. */}
            <TabsContent value={FC_TRANSFER_DIRECTION.OUTBOUND} className="hidden" aria-hidden tabIndex={-1} />
            <TabsContent value={FC_TRANSFER_DIRECTION.INBOUND} className="hidden" aria-hidden tabIndex={-1} />
        </Tabs>
    );
}
